import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const bulkDeleteBillOfMaterials = {
  name: "bulkDeleteBillOfMaterials" as const,
  input: z.object({
    billOfMaterialsIds: z.array(billOfMaterialsIdFormat.schema),
  }),
  output: z.object({ success: z.boolean() }),
};
